export default {
    state: {
        Main: '',
        FAQ: '',
        Contacts: '',
        PageContent: '',
        getVersionApp: ''
    },
    mutations: {
        setMain(state, payload) {
            state.Main = payload
        },
        setFAQ(state, payload) {
            state.FAQ = payload
        },
        setContacts(state, payload) {
            state.Contacts = payload
        },
        setPageContent(state, payload) {
            state.PageContent = payload
        },
        setAppVersion(state, payload) {
            state.getVersionApp = payload.detail
        }
    },
    actions: {
        async getMainData({dispatch, commit}) {
            dispatch('sendRequest', {method: 'GET', endpoint: '/index'})
            .then(response => response.json())
            .then(data => {
                commit('setMain', data)
            })
        },
        async getMainFAQ({dispatch, commit}) {
            dispatch('sendRequest', {method: 'GET', endpoint: '/faq'})
            .then(response => response.json())
            .then(data => {
                commit('setFAQ', data)
            })
        },
        async getContacts({dispatch, commit}) {
            dispatch('sendRequest', {method: 'GET', endpoint: '/pages/contacts'})
            .then(response => response.json())
            .then(data => {
                commit('setContacts', data)
            })
        },
        async getPageContent({dispatch, commit}, data) {
            dispatch('sendRequest', {method: 'GET', endpoint: `/pages/${data.page}`, language: data.lang ? data.lang : ''})
            .then(response => response.json())
            .then(data => {
                commit('setPageContent', data)
            })
        },
        async getVersionApp({dispatch, commit}) {
            dispatch('sendRequest', {method: 'GET', endpoint: '/index/shared'})
            .then(response => response.json())
            .then(data => {
                commit('setAppVersion', data)
            })
        }
    },
    getters: {
        getMainData(state) {
            return state.Main
        },
        getMainFAQ(state) {
            return state.FAQ
        },
        getContacts(state) {
            return state.Contacts
        },
        getPageContent(state) {
            return state.PageContent
        },
        getVersionApp(state) {
            return state.getVersionApp
        }
    }
}